export const A11Y_BUTTON_LABEL_TRANS_FEATURE = 'Accessibility';
export const A11Y_BUTTON_LABEL_TRANS_KEY = 'Accessibility_Skip_Nav_Button_Text';
export const A11Y_BUTTON_LABEL_TRANS_DEFAULT_VAL = 'Skip to Main Content';
